import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { colors, fonts } from "@theme/Themes";

import StyledContainer from "@GlobalComponents/StyledContainer";
import styled from "styled-components";

export const Container = styled(StyledContainer)`
  margin: 16px 0;
  gap: 10px;
  position: relative;

  .tips-title {
    color: ${colors.text};
    font-family: ${fonts.titlesFont};
    font-size: 1.8rem;
    margin-bottom: 13px;

    > * {
      color: ${colors.text};
    }
  }

  &.error {
    .MuiButtonBase-root,
    .MuiInputBase-root {
      border: 1px solid ${colors.error} !important;
      overflow: hidden;
    }
  }

  .no-tip-message {
    color: ${colors.error};
    font-size: 14px;
  }

  .MuiInputAdornment-root {
    p {
      font-size: 1.6rem;
    }
  }

  @keyframes errorAnimation {
    0%,
    50%,
    100% {
      opacity: 0;
    }

    25%,
    75% {
      opacity: 1;
    }
  }
`;

export const Title = styled.h2`
  color: ${colors.text};
  font-size: 2rem;
  margin-bottom: 13px;
  line-height: 22px;

  > * {
    color: ${colors.text};
  }
`;

export const ToggleList = styled(ToggleButtonGroup)`
  align-items: stretch;
  gap: 6px;
  justify-content: space-between;
  width: 100%;
`;

export const TipButton = styled(ToggleButton)`
  &.overwrite {
    border: 2px solid ${colors.border} !important;
    background-color: ${colors.paper};
    border-radius: 6px !important;
    color: ${colors.text} !important;
    display: flex;
    flex-direction: column;
    flex: 100% 1 1;
    gap: 3px;
    padding: 9px 8px;
    text-transform: none;

    strong {
      font-size: 1.6rem;
      line-height: 1.6rem;

      &.smaller {
        font-size: 1.3rem;
      }
    }

    span {
      font-family: ${fonts.textFont};
      font-size: 1.3rem;
      font-weight: 400;
      line-height: 1.3rem;
    }

    &:hover {
      background-color: ${colors.paper};
      border-color: ${colors.borderDark};
    }

    &.Mui-selected {
      background-color: transparent !important;
      border: 2px solid ${colors.text} !important;
      pointer-events: none;
    }
  }
`;
